import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { GithubOutlined, WechatOutlined, QqOutlined } from '@ant-design/icons';
import './index.css';

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;
const FooterItem= () => {
  return (
    <AntFooter className="footer">
        <Text>@ 2025 我的博客</Text>
        <Space size="large" className="social-links">
            <Link href="#" target="_blank" title='Github'>
              <GithubOutlined style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.65)' }} />
            </Link>
            <Link href="#" target="_blank" title='Wechat'>
              <WechatOutlined style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.65)' }} />
            </Link>
            <Link href="#" target="_blank" title='Qq'>
              <QqOutlined style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.65)' }} />
            </Link>
      </Space>
    </AntFooter>
  )
}

export default FooterItem;